import _ from 'lodash'

export interface IStorageService {
    name: string
    get<T>(key: string): T
    set<T>(key: string, value: T): void
    keys(): string[]
    delete(key: string): void
    clear(): void
}

class StorageService implements IStorageService {
    name = ''
    storage
    constructor(name: string, storage: Storage) {
        this.name = name;
        this.storage = storage;
    }

    get<T>(key: string): T {
        const item = this.storage.getItem(key)
        try {
            return JSON.parse(item) as T
        } catch (e) {
            return (item as any as T)
        }
    }

    set<T>(key: string, value: T): void {
        if (_.isNil(value)) {
            console.error('Invalidate value:', value)
        }
        this.storage.setItem(key, JSON.stringify(value))
    }

    keys(): string[] {
        return _.map(_.range(this.storage.length), index => {
            return this.storage.key(index)
        })
    }

    delete(key: string): void {
        this.storage.removeItem(key)
    }

    clear(): void {
        this.storage.clear()
    }
}

export const LocalStorageService = new StorageService('LocaleStorageService', localStorage)
